import { useState, useCallback } from "react";
import { useLanguage } from "lang/Translate";

// common components
import BallPulseLoader from "components/common/BallPulseLoader/BallPulseLoader";

// hooks and utilities
import useEventListener from "hooks/useEventListener";

// assets
import offlineIcon from "assets/icons/offline.svg";
import onlineIcon from "assets/icons/online.svg";

import "./Offline.scoped.scss";

const Offline = () => {
	const [showOverlay, setShowOverlay] = useState(!window.navigator.onLine);
	const [offline, setOffline] = useState(!window.navigator.onLine);
	const lang = useLanguage();

	useEventListener(
		window,
		"offline",
		useCallback(() => {
			setOffline(true);
			setShowOverlay(true);
		}, [])
	);

	useEventListener(
		window,
		"online",
		useCallback(() => {
			setOffline(false);
			setTimeout(() => setShowOverlay(false), 1500);
		}, [])
	);

	return (
		<div className={`container ${showOverlay && "show"}`}>
			<div className={`offline ${offline && "show"}`}>
				<img src={offlineIcon} alt="offline" />
				{lang === "PL" && <p>Ups, wygląda na to, że jesteś offline</p>}
				{lang !== "PL" && <p>Oops, it looks like you are offline</p>}

				<div className="waiting">
					{lang === "PL" ? "Ponowne łączenie" : "Reconnecting"}
					<BallPulseLoader color="rgba(0, 0, 0, 0.85)" />
				</div>
			</div>

			<div className={`online ${!offline && showOverlay && "show"}`}>
				<img src={onlineIcon} alt="You are back online" />
				{lang === "PL" && <p>Jesteś z powrotem online</p>}
				{lang !== "PL" && <p>You are back online</p>}

				<div className="waiting">
					<BallPulseLoader color="rgba(0, 0, 0, 0.85)" />
				</div>
			</div>
		</div>
	);
};

export default Offline;
